import { useState, useEffect, useRef } from 'react';
import { fetchOrgEmoji } from '@/lib/api';
import type { CustomEmoji } from '@goodchat/shared/types';

const cache = new Map<string, { emoji: CustomEmoji[]; map: Map<string, string> }>();

export function useOrgEmoji(orgId: string | undefined) {
  const [emoji, setEmoji] = useState<CustomEmoji[]>([]);
  const [emojiByShortcode, setEmojiByShortcode] = useState<Map<string, string>>(new Map());
  const fetchedRef = useRef<string | null>(null);

  useEffect(() => {
    if (!orgId) return;

    const cached = cache.get(orgId);
    if (cached) {
      setEmoji(cached.emoji);
      setEmojiByShortcode(cached.map);
      return;
    }

    if (fetchedRef.current === orgId) return;
    fetchedRef.current = orgId;

    fetchOrgEmoji(orgId)
      .then((data) => {
        const emojiList = data.emoji ?? [];
        const map = new Map<string, string>();
        for (const e of emojiList) {
          map.set(`:${e.name}:`, (e as unknown as { url?: string; imageUrl?: string }).url ?? (e as unknown as { url?: string; imageUrl?: string }).imageUrl ?? '');
        }
        cache.set(orgId, { emoji: emojiList, map });
        setEmoji(emojiList);
        setEmojiByShortcode(map);
      })
      .catch(() => {});
  }, [orgId]);

  return { emoji, emojiByShortcode };
}
